<template>
  <easy-page-template
      title="システムに関して、何を行いますか？"
      subtitle="システムに関して行うことを、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconTradeContractTradeContract"
          title="契約を作成する"
          to="/easy/tradeContractHome/tradeContract"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconTradeContractTradeResult"
          title="取引実績を見る"
          to="/easy/tradeContractHome/tradeResult"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import imageTradeContract from "./assets/image_trade_contract.svg";
import iconTradeContractTradeContract from "./assets/icon_trade_contract_trade_contract.svg";
import iconTradeContractTradeResult from "./assets/icon_trade_contract_trade_result.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "TradeContractHome",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      imageTradeContract,
      iconTradeContractTradeContract,
      iconTradeContractTradeResult,
    }
  }
}
</script>

<style scoped>

</style>
